var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:({
    callback: function ($event) { return _vm.$emit('observe-node-visibility', { visible: $event }); },
  }),expression:"{\n    callback: $event => $emit('observe-node-visibility', { visible: $event }),\n  }"}]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }